// extracted by mini-css-extract-plugin
export default {"contentContainer":"ProductSwitcherContent_contentContainer__75h1-","item":"ProductSwitcherContent_item__AIZ85"};